<template>
    <div id="pick-material-task">
        <div style="width:100%;heigh:100%;">
            <el-card class="table_searchbar">
                <el-row :gutter="20">
                    <el-col :span='5'>
                        <div @keydown.enter="btnSearch()" class="span_flex">
                            <span class="title">到货单号：</span>
                            <el-select size="small" @visible-change="closeSelect($event)"  clearable    filterable remote :remote-method="remoteMethod" 
                                :loading="loading" style="max-width:180px;" v-model="searchForm.arrivalId" placeholder="到货单号" >
                                <el-option v-for="item in arrivalList" :key="item.id" :label="item.arrivalCode" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">采购单号：</span>
                            <el-select size="small" style="max-width:180px;" @visible-change="closeSelect1($event)"  clearable    filterable remote :remote-method="remoteMethod1" 
                                :loading="loading" v-model="searchForm.purchaseId" placeholder="采购单号" >
                                <el-option v-for="item in purchaseSelectList" :key="item.purchaseId" :label="item.purchaseCode" :value="item.purchaseId"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">物料编码：</span>
                            <el-select size="small" style="max-width:180px;" clearable :remote-method="query=>this.remoteMethod4(query)" @visible-change='closeMaterialSelect' 
                                :loading="loading" remote="remote"  filterable="filterable" v-model="searchForm.materialId" placeholder="物料编码" >
                                <el-option v-for="item in materialList" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">物料名称：</span>
                            <el-select size="small" style="max-width:180px;" clearable :remote-method="query=>this.remoteMethod4('',query)" @visible-change='closeMaterialSelect'
                                 :loading="loading" remote="remote"  filterable="filterable" v-model="searchForm.materialId" placeholder="物料名称" >
                                <el-option v-for="item in materialList" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div style="text-align:right">
                            <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                                {{ showMore ? '收起' : '展开' }}
                                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                            </a>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                            <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-collapse-transition>
                    <div v-show="showMore">
                        <el-row :gutter="20">
                            <el-col :span="10">
                                <div class="" @keydown.enter="btnSearch()">
                                    <span class="title">质检时间：</span>
                                    <el-date-picker style="width:533px" v-model="searchForm.inspectionTime" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="" @keydown.enter="btnSearch()">
                                    <span class="title" style="width:86px;margin-left:-16px">质检人：</span>
                                    <el-select size="small" filterable clearable style="max-width:180px;" v-model="searchForm.inspectionUserId" placeholder="质检人" clearable>
                                        <el-option v-for="item in inspectionUserList" :key="item.inspectionUserId" :label="item.inspectionUserName" :value="item.inspectionUserId"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-collapse-transition>
            </el-card>
            <el-card class="table-card">
                <el-table :data="tableData" style="width: 100%" class="deviceTable" >
                    <el-table-column type="index" label="序号" width="60"></el-table-column>
                    <el-table-column prop="arrivalCode" label="到货单号" min-width="120"></el-table-column>
                    <el-table-column prop="purchaseCode" label="采购单号" min-width="110"></el-table-column>
                    <el-table-column prop="materialCode" label='物料编码' min-width="110"></el-table-column>
                    <el-table-column prop="materialName" label='物料名称' min-width="110"></el-table-column>
                    <el-table-column prop="specification" label='规格型号' min-width="110"></el-table-column>
                    <el-table-column prop="arrivalAmount" label='到货数量' min-width="80"></el-table-column>
                    <el-table-column prop="qualifiedAmount" label='合格数量' min-width="80"></el-table-column>
                    <el-table-column prop="yield" :formatter="parseYield" label='合格率' min-width="110"></el-table-column>
                    <el-table-column prop="inspectionTime" :formatter="$commonUtil.changeToDate" label='质检时间' min-width="120"></el-table-column>
                    <el-table-column prop="inspectionUserName"  label='操作人' min-width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" fixed="right" width="140">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="permission.btn_incomingInspection_updateIncoming" @click="showEditDialog(scope.row)" size="small">编辑</el-button>
                            <el-button type="text" v-if="permission.btn_incomingInspection_list" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="page" v-if="tableData.length > 0">
                    <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                        <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
            <!-- 编辑来料检验开始 -->
            <el-dialog title="编辑来料检验" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span==5?'49%':'64%'"  center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                    
                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="title">到货单号：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                               {{addForm.arrivalCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">采购单号：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.purchaseCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">到货日期：</span>
                            <el-form-item class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.arrivalTime}}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="title">物料编码：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.materialCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">物料名称：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.materialName}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">规格型号：</span>
                            <el-form-item class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.specification}}
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom:0px">
                        <el-col :span="8">
                            <span class="title">到货数量：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.arrivalAmount}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">合格数量：</span>
                            <el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}" prop="qualifiedAmount" :rules="rules.qualifiedAmount">
                                <el-input @input="qualifiedAmountChange" size="small" v-model="addForm.qualifiedAmount" maxlength="100"  placeholder="合格数量"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">合格率：</span>
                            <el-form-item class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                {{addForm.yield}}
                            </el-form-item>
                        </el-col>
                    </el-row>
                   
                    <el-row>
                        <el-col :span="8">
                            <span class="title">检验结果：</span>
                            <el-form-item class="value" prop="inspectionResult" :rules="rules.inspectionResult" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                               <el-select size="small"   v-model="addForm.inspectionResult" placeholder="检验结果" filterable style="display:block;max-width:180px">
                                    <el-option key="0" :disabled="addForm.qualifiedAmount==='0'" label="合格" :value="0"></el-option>
                                    <el-option :disabled ="Number(addForm.qualifiedAmount)>0" key="1" label="不合格退回" :value="1"></el-option>
                                    <el-option key="2" label="特采" :value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <h4>检验数据明细</h4>
                        </el-col>
                    </el-row>
                   <el-row :gutter="20" >
                        <el-col :span="24">
                            <el-button type="primary" size="medium" @click="addItem()">新增明细</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="addForm.detailList" stripe style="width: 100%;margin-bottom:10px;" class="marterial-table">
                        <el-table-column  min-width="40" label="序号">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span>{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="检验项目" min-width="100">
                            <template slot-scope="scope">
                                <el-form-item  :prop="`detailList[${scope.$index}].inspectionProject`"  :rules="rules.inspectionProject" >
                                    <el-input v-model="scope.row.inspectionProject"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="标准范围" min-width="80">
                            <template slot-scope="scope">
                                <el-form-item >
                                   <el-input v-model="scope.row.standardRange"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>

                        <el-table-column label="实测" min-width="70">
                            <template slot-scope="scope">
                                <el-form-item >
                                   <el-input v-model="scope.row.actualRange"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>

                        <el-table-column label="不合格数量" min-width="130">
                            <template slot-scope="scope">
                                <el-form-item :prop="`detailList[${scope.$index}].unqualifiedAmount`"  :rules="rules.unqualifiedAmount">
                                    <el-input v-model="scope.row.unqualifiedAmount"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="不合格原因描述" min-width="130">
                            <template slot-scope="scope">
                                <el-form-item >
                                    <el-input v-model="scope.row.unqualifiedDescription"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <div class="delete" type="primary" @click="removeItem(scope.$index)"></div>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitEditDialog">保 存</el-button>
                    <el-button @click="cancelEditDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 编辑来料检验结束 -->

            <!-- 查看来料检验开始 -->
            <el-dialog title="" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'45%':'64%'"   center :close-on-click-modal="false">
                <div id='pdfDom'>
                    <h4 style="text-align: center;position: relative;top: 0px;font-size: 18px;margin-bottom: 10px;">来料检验详情</h4>
                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="title">到货单号：</span>
                            <span>{{addForm.arrivalCode}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">采购单号：</span>
                            <span>{{addForm.purchaseCode}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">到货日期：</span>
                            <span>{{addForm.arrivalTime}}</span>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="title">物料编码：</span>
                            <span>{{addForm.materialCode}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">物料名称：</span>
                            <span>{{addForm.materialName}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">规格型号：</span>
                            <span>{{addForm.specification}}</span>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="title">到货数量：</span>
                            <span>{{addForm.arrivalAmount}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">合格数量：</span>
                            <span>{{addForm.qualifiedAmount}}</span>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">合格率：</span>
                            <span>{{addForm.yield}}</span>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" style="margin-bottom:30px">
                        <el-col :span="8">
                            <span class="title">检验结果：</span>
                            <span>{{addForm.inspectionResult}}</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="24">
                            <h4>检验数据明细</h4>
                        </el-col>
                    </el-row>
                    <el-table :data="detailList" stripe style="width: 100%;margin-bottom:10px;" class="part-table">
                        <el-table-column label="序号" type="index" width="60"></el-table-column>
                        <el-table-column label="检验项目" min-width="90" prop="inspectionProject"></el-table-column>
                        <el-table-column label="标准范围" min-width="110" prop="standardRange"></el-table-column>
                        <el-table-column label="实测" min-width="80" prop="actualRange"></el-table-column>
                        <el-table-column label="不合格数量" min-width="80" prop="unqualifiedAmount"></el-table-column>
                        <el-table-column label="不合格原因描述" min-width="140" prop="unqualifiedDescription"></el-table-column>
                    </el-table>
                </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="downInfo" >导出pdf</el-button>
                        <el-button @click="cancelViewDialog" >取 消</el-button>
                    </span>
                
            </el-dialog>
            <!-- 查看来料检验结束 -->

        </div>
    </div>
</template>

<script>
import outputPdf from '@/util/outputPdf'
export default {
    name: 'IncomingInspection',
    data() {
        let that = this
        return {
            showMore:false,
            purchaseSelectList:[],
            loading:false,
            arrivalList:[],
            inspectionUserList:[],
            editDialogVisible:false,
            viewDialogVisible:false,
            fristLoad: false,
            addForm:{
                qualifiedAmount:null,
                inspectionResult:null,
                detailList:[]
            },
            detailList:[],
            materialList:[],
            showPage: 1,
            rules:{
                inspectionProject:[
                    { required: true, message: '请输入检验显目名称', trigger: 'blur' }
                ],
                inspectionResult:[
                    { required: true, message: '请选择检验结果', trigger: 'blur' }
                ],
                qualifiedAmount:[
                    { required: true, message: '请输入合格数量', trigger: 'blur' },
                    {validator(rule, value, callback) {
                        if(value){
                            value = Number(value)
                            if(Number.isNaN(value)){
                                callback(new Error('合格数量必须为数字'))
                            }else{
                                if(value<0){
                                    callback(new Error('合格数量不能小于零'))
                                }else{
                                    if(value>that.addForm.arrivalAmount){
                                        callback(new Error('合格数量不能大于到货数量'))
                                    }else{
                                        if(Number(value).toFixed(2)!=value){
                                            callback(new Error('合格数量最多可保留2位小数'))
                                        }else{
                                            callback()
                                        }
                                    }
                                }
                            }
                        }else{
                            callback(new Error('合格数量不能小于零'))
                        } 
					},trigger: 'blur'}
                ],
                unqualifiedAmount:[
                    {validator(rule, value, callback) {
                        
                        if(value){
                            value = Number(value)
                            if(Number.isNaN(value)){
                                callback(new Error('不合格数量必须为数字'))
                            }else{
                                if(value<0){
                                    callback(new Error('合格数量不能小于零'))
                                }else{
                                    let count = that.addForm.arrivalAmount-Number(that.addForm.qualifiedAmount)
                                    if(value>count){
                                        
                                        callback(new Error(`数量不能大于总不合格数量(${count})`))
                                    }else{
                                        if(Number(value).toFixed(2)!=value){
                                            callback(new Error('不合格数量最多可保留2位小数'))
                                        }else{
                                            callback()
                                        }
                                    }
                                }
                            }
                        }else{
                            callback(new Error('不合格数量不能为空'))
                        } 
					},trigger: 'blur'}
                ],
            },
            W: false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm: {
                arrivalId:null,
                purchaseId:null,
                materialId:null,
                inspectionTime:[],
                inspectionUserId:null
            },
            tableData: [
                {arrivalAmount:200,qualifiedAmount:131.34}
            ],
            tableCurrentPage: 1,
            tableTotalPage: 2,
            viewDialogVisible: false,
            data: {
                token: localStorage.getItem("token"),
            },
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted: function () {
        this.initTable();
        this.loadArrivalList()
        this.loadMaterialList()
        this.loadPurchaseList()
        this.loadInspectionUserList()
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 5 : 6
        }
    },
    deactivated: function () {
        console.log("deactivated");
    },
    methods: {
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        qualifiedAmountChange(ev){
            if(this.addForm.arrivalAmount&&(Number(ev)>0||ev==='0')){
                let arrivalAmount = Number(this.addForm.arrivalAmount)
                let num = Number(ev)/arrivalAmount*100
                if(num>=100){
                    num=100
                }
                if(Number(num).toFixed(2)!=num){
                    num = Number(num).toFixed(2)
                }
                if(ev==='0'&&this.addForm.inspectionResult===0){
                    this.$set(this.addForm,'inspectionResult',null)
                }
                if(Number(ev)>0&&this.addForm.inspectionResult===1){
                    this.$set(this.addForm,'inspectionResult',null)
                }
                
                this.$set(this.addForm,'yield',num+'%')
               
            }else{
                this.$set(this.addForm,'yield','')
            }
        },

        parseYield(rowData){
            if(rowData.arrivalAmount&&(rowData.qualifiedAmount>0||rowData.qualifiedAmount===0)){
                let num = rowData.qualifiedAmount/rowData.arrivalAmount*100
                if(num>=100){
                    num=100
                }
                if(Number(num).toFixed(2)!=num){
                    num = Number(num).toFixed(2)
                }
                return num + '%'
            }else{
                return ''
            }
        },

        async loadArrivalList(arrivalCode){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listArrivalCode',params: {arrivalCode},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            this.arrivalList = res.data
        },
        async loadInspectionUserList(){
            let res = await this.$RequestUtil.getAsync({url: '/api/incomingInspection/getInspectionUserList',params: {},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            this.inspectionUserList = res.data
        },
        

        async loadPurchaseList(purchaseCode,executingStatus){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listPurchaseCode',params: {purchaseCode,executingStatus},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            this.purchaseSelectList =  res.data
        },

        async loadMaterialList(materialCode,materialName){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: "/api/select/listMaterial",params: {materialCode,materialName}});
            if(code==0){
                this.materialList = data
            }
        },

        async remoteMethod(query){
            this.loading = true
            await this.loadArrivalList(query)
            this.loading = false
        },

        async remoteMethod1(query){
            this.loading = true
            await this.loadPurchaseList(query)
            this.loading = false
        },

        async remoteMethod4(materialCode,materialName) {
            this.loading = true;
            await this.loadMaterialList(materialCode,materialName)
            this.loading = false
        },

        closeSelect(ev){
            if(!ev){
                this.loadArrivalList()
            }
        },

        async closeSelect1(ev){
            if(!ev){
                await this.loadPurchaseList()
            }
        },

        async closeMaterialSelect(ev) {
            if (!ev) {
                await this.loadMaterialList()
            }
        },

        removeItem(index) {
            this.addForm.detailList.splice(index, 1)
        },

        addItem() {
            this.addForm.detailList.push({})
            
        },

        reload() {
            this.initTable();
        },
    
        
        async loadIncomingInspectionDetialById(incomingInspectionId){
            let res = await this.$RequestUtil.getAsync({url: '/api/incomingInspection/getIncomingMsg',params: {incomingInspectionId},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            return res.data
        },
        

        cancelEditDialog() {
            this.editDialogVisible = false
            this.$refs['editForm'].resetFields()
            this.addForm = {
                qualifiedAmount:null,
                inspectionResult:null,
                detailList:[]
            }
            this.detailList = []
        },

        cancelViewDialog() {
            this.viewDialogVisible = false
            this.addForm = {
                qualifiedAmount:null,
                inspectionResult:null,
                detailList:[]
            }
            
            this.detailList = []
        },

        
        showEditDialog: async function (rowData) {
            
            this.addForm = commonUtils.cloneObj(rowData)
            this.$set(this.addForm,'detailList',[])
            let {arrivalTime,inspectionResult,qualifiedAmount,detailDto} =  await this.loadIncomingInspectionDetialById(rowData.id)
            this.editDialogVisible = true;
            this.addForm.detailList = detailDto
            this.addForm.arrivalTime =  commonUtils.timestampToDate(arrivalTime,true) 
            // this.addForm.inspectionResult = inspectionResult
            this.$set(this.addForm,'inspectionResult',inspectionResult)
            this.addForm.qualifiedAmount = qualifiedAmount
            this.qualifiedAmountChange(this.addForm.qualifiedAmount)
            
        },

            
        async showViewDialog(rowData) {
           
            this.addForm = commonUtils.cloneObj(rowData)
            let {arrivalTime,inspectionResult,qualifiedAmount,detailDto} =  await this.loadIncomingInspectionDetialById(rowData.id)
            this.viewDialogVisible = true;
            this.detailList = detailDto
            this.addForm.arrivalTime = commonUtils.timestampToDate(arrivalTime,true) 
            let resultOption = [
                {label:"合格",value:0},
                {label:"不合格退回",value:1},
                {label:"特采",value:2}
            ]
            this.addForm.inspectionResult = (resultOption.find(item=>item.value===inspectionResult)||{}).label
            this.addForm.qualifiedAmount =  qualifiedAmount
            this.qualifiedAmountChange(this.addForm.qualifiedAmount)
            
        },

        submitEditDialog() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/incomingInspection/updateIncoming',
                        type: 'sync',
                        params: this.addForm,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('编辑成功')
                                this.initTable();
                                this.cancelEditDialog()
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })
                }
            })
        },
        
        btnSearch: function () {
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch() {
            let form = this.searchForm;
            this.btnPressType = 2;
            form.arrivalId = null
            form.purchaseId = null
            form.materialId = null
            form.inspectionTime = []
            form.inspectionUserId = null
        },

        search: function () {
            let temp;
            switch (this.btnPressType) {
                case 1:
                    temp = commonUtils.cloneObj(this.searchForm);
                    this.searchFormTemp = commonUtils.cloneObj(temp);
                    break;
                case 0:
                    temp = {
                        arrivalId:null,
                        purchaseId:null,
                        materialId:null,
                        inspectionTime:[],
                        inspectionUserId:null
                    };
                    break;
                case 2:
                    temp = this.searchFormTemp;
                    break;
                case 3:
                    temp = this.searchFormTemp;
                    break;
            }
            // return
            let inspectionTimeStartStr,inspectionTimeEndStr;
            if(temp.inspectionTime&&temp.inspectionTime.length==2){
                inspectionTimeStartStr = temp.inspectionTime[0]
                inspectionTimeEndStr = temp.inspectionTime[1]
            }

            this.$RequestUtil.get({
                url: '/api/incomingInspection/list',
                type: 'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    inspectionTimeStartStr,
                    inspectionTimeEndStr,
                    arrivalId:temp.arrivalId,
                    purchaseId:temp.purchaseId,
                    materialId:temp.materialId,
                    inspectionUserId:temp.inspectionUserId,
                },
                success: (res) => {
                    if (res.code == 0) {
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable: function () {
            this.search();
        },
        
        downInfo(){
//             window.scrollTo(0, 0);
// 　　　　　　  this.getPdf('#pdfDom','来料检验详情');
            let element = document.querySelector('#pdfDom')
             outputPdf({
                    element,
                    // contentHeight:500,
                    // contentWidth:400,
                    filename:'来料检验详情.pdf'
                }).then(()=>{
                    log('导入成功')
                })
        },
    
        async printOrder(rowData,type){
            let StockOutInfo = commonUtils.cloneObj(rowData)
            if(type!=1){
                await this.loadStockInDetail(rowData.materialRequisitionId)
            }
            
            StockOutInfo.stockInDetailList = this.stockInDetailList
            localStorage.setItem('printStockInfo',JSON.stringify(StockOutInfo))
            let routeUrl = this.$router.resolve({path: "/Print/PrintPickMaterial"});
            window.open(routeUrl.href, '_blank');
        },
    }
}
</script>

<style scoped>
    .table_searchbar .title11 {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }

    /* .title {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
        display: inline-block;
        text-align: right;
        width: 70px;
    } */

    .add_form .value {
        display: inline-block;
    }

    .el-row {
        margin-bottom: 20px;

        & :last-child {
            margin-bottom: 0;
        }
    }

    .import_upload {
        display: inline;
    }

    .page {
        display: flex;
        justify-content: flex-end;
    }

    @media screen and (max-width: 1450px) {
        .page {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 30px;
        }
    }

    .total_page {
        margin-top: 20px;
        margin-right: 26px;
        color: #606266;
        font-size: 14px;
    }
    .delete {
        width: 18px;
        height: 19px;
        background-image: url('../../../static/img/del.png');
        cursor: pointer;
        background-repeat: no-repeat;
    }

    .delete:hover {
        background-image: url('../../../static/img/del-hover.png');
        background-repeat: no-repeat;
    }
</style>
<style>
    .table_searchbar .el-button--mini,
    .el-button--mini.is-round {
        padding: 7px 10px;
    }

    @media screen and (max-width: 1366px) {
        #pick-material-task .el-date-editor.el-input,
        #pick-material-task .el-date-editor.el-input__inner {
            width: 176px !important;
        }
    }

    @media screen and (min-width: 1400px) and (max-width: 1920px) {
        .y_records_width {
            width: 220px !important;
        }
    }
</style>




// WEBPACK FOOTER //
// src/views/stock/IncomingInspection.vue